/** Kruhový buffer pro klouzavé okno ODF. */
export class RingBuffer {
  private readonly buf: Float32Array;
  private pos = 0;
  private count = 0;

  constructor(readonly capacity: number) {
    this.buf = new Float32Array(capacity);
  }

  get length(): number {
    return this.count;
  }

  push(x: number): void {
    this.buf[this.pos] = x;
    this.pos = (this.pos + 1) % this.capacity;
    if (this.count < this.capacity) this.count++;
  }

  pushAll(xs: ArrayLike<number>): void {
    for (let i = 0; i < xs.length; i++) this.push(xs[i]);
  }

  /** Zkopíruje nejnovějších `out.length` hodnot chronologicky (nejstarší první). Vrátí počet zapsaných. */
  read(out: Float32Array): number {
    const n = Math.min(this.count, out.length);
    const start = (this.pos - n + this.capacity) % this.capacity;
    for (let i = 0; i < n; i++) out[i] = this.buf[(start + i) % this.capacity];
    return n;
  }

  reset(): void {
    this.pos = 0;
    this.count = 0;
  }
}
